import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateSchedulesControllerModule } from './controllers/TemplatesCreateSchedulesController';
import { TemplatesCreateSchedulesCreateView } from './create/create';

export const TemplatesCreateSchedulesView = angular
  .module('acme.view.application.templates.create.schedules', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.plus',
    'acme.common.directive.minus',
    'acme.common.directive.numeric',
    'acme.common.directive.dataGrid',
    TemplatesCreateSchedulesControllerModule,
    TemplatesCreateSchedulesCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.schedules',
      url: '/schedules',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/schedules.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Schedules',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules',
      url: '/schedules',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/schedules.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Schedules',
      },
    });
  }).name;
